import { createFileRoute } from "@tanstack/react-router";
import { ToolPage } from "@/components/dashboard/ToolPage";
import { LiquidityTracker, ProximityRadar } from "@/components/dashboard/terminal/DeskTools";
import { useGoldPrice } from "@/hooks/useGoldPrice";

export const Route = createFileRoute("/_authenticated/dashboard/liquidity")({
  head: () => ({
    meta: [
      { title: "Liquidity Tracker | XAU Pro Academy" },
      { name: "description", content: "Asian range and previous day liquidity raids on XAUUSD for members." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: LiquidityPage,
});

function LiquidityPage() {
  const { price } = useGoldPrice();
  return (
    <ToolPage eyebrow="Liquidity desk" title="Liquidity Tracker" intro="Session and previous day liquidity, which side has been raided and whether the raid was accepted or rejected."
      note="Observational reading of published levels. Not a signal and not execution advice.">
      <div className="grid gap-6 lg:grid-cols-2">
        <LiquidityTracker price={price ?? null} />
        <ProximityRadar price={price ?? null} />
      </div>
    </ToolPage>
  );
}
